export default __webpack_public_path__ + "static/media/37_jpeg.23e3b526.jpg";